import OnvoBase, { JobUpdateEvent } from "@/base";
import { OnvoIntegrationTables } from "../integration_tables/index.js";

export class OnvoIntegration extends OnvoBase {
    tables: OnvoIntegrationTables;
    #id: string;

    constructor(id: string, apiKey: string, options?: { endpoint: string }) {
        super(apiKey, options);
        this.tables = new OnvoIntegrationTables(id, apiKey, options);
        this.#id = id;
    }

    /**
     * Initializes the integration.
     *
     * @return {Promise<{success: boolean, id: string}>} A promise that resolves to an object containing the success and id of the integration.
     */
    initialize(callback?: (event: JobUpdateEvent) => void) {
        return this._fetchStreamBase(
            "/api/integrations/" + this.#id + "/initialize",
            "POST",
            undefined,
            callback
        ) as Promise<{ success: boolean, id: string }>;
    }

}